var render, staticRenderFns
import script from "./PzBaseForm.vue?vue&type=script&lang=js&"
export * from "./PzBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b6cc7f')) {
      api.createRecord('29b6cc7f', component.options)
    } else {
      api.reload('29b6cc7f', component.options)
    }
    
  }
}
component.options.__file = "src/commons/forms/PzBaseForm.vue"
export default component.exports